<template>
  <div>
    <Header />
    <div :class="$style.linksContainer">
      <HeadingHuge :class="$style.heading">
        {{ SignupText.headerText }}
      </HeadingHuge>
      <ParagraphBody :class="$style.subheader">
        {{ SignupText.subHeaderText }}
      </ParagraphBody>
      <div>
        <GridAuto
          :class="$style.grid"
          hasGap
          minWidth="20rem"
        >
          <div
            v-for="(item, index) in googleLoginItems"
            :key="item.id"
            :class="$style.listItem"
            data-test-id="AdminGoogleRegistrationLinksContainer_listItem"
          >
            <div :class="$style.textContainer">
              <div :class="$style.circle">
                {{ index + 1 }}
              </div>
              {{ item.text }}
            </div>

            <div :class="{ [$style.buttonContainer]: index === 0 }">
              <Button
                :href="item.link"
                :text="item.linkText"
                @click="handleGoogleLoginClick(item)"
              />
            </div>
          </div>
        </GridAuto>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Button,
  GridAuto,
  HeadingHuge,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  RouteGenerator,
  SignupConsts,
} from 'client/util/Constants';
import Cookies from 'js-cookie';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Header from 'client/signup/components/Header.vue';

const { clientTypeCookie, SignupText } = SignupConsts;
const { login, signup, userPortalLogin } = RouteGenerator;
const { admin, user } = SignupConsts.clientType;

export default {
  name: 'AdminGoogleRegistrationLinksContainer',

  components: {
    Button,
    GridAuto,
    Header,
    HeadingHuge,
    ParagraphBody,
  },

  data() {
    return {
      SignupText,
      loading: false,
      errorMessage: '',
      googleLoginItems: [
        {
          id: 1,
          cookie: user,
          link: userPortalLogin,
          linkText: 'Login to User Portal',
          text: 'Are you trying to login to the User Portal?',
        },
        {
          id: 2,
          link: signup,
          linkText: 'Signup for JumpCloud',
          text: 'Would you like to sign up for an Admin Portal account?',
        },
        {
          id: 3,
          cookie: admin,
          link: login,
          linkText: 'Login to Admin Portal',
          text: 'Would you like to return to Admin Portal?',
        },
      ],
    };
  },

  methods: {
    handleGoogleLoginClick(item) {
      const {
        cookie,
        linkText,
      } = item;

      EventHelper.triggerAdminGoogleRegistrationPageClick(
        { linkText },
      );
      if (cookie) Cookies.set(clientTypeCookie, cookie);
    },
  },
};
</script>

<style module>
@value (max-width-medium) from '~css/breakpoints.css';

.linksContainer {
  margin: 5rem auto;
  text-align: center;
  width: fit-content;
}

.listItem {
  margin: 1rem;
}

.heading {
  font-family: var(--serifFont);
}

.subheader.subheader {
  font-size: 20px;
}

.textContainer {
  display: inline-flex;
  margin-bottom: 1.5rem;
  text-align: left;
}

.circle {
  align-items: center;
  border: 1px solid currentColor;
  border-radius: 50%;
  color: currentColor;
  display: flex;
  height: 10px;
  justify-content: center;
  margin-right: 1rem;
  padding: 1rem;
  width: 10px;
}

.grid {
  padding-top: 3rem;
}

.buttonContainer {
  padding-right: 1rem;
}

@media (max-width: max-width-medium) {
  .linksContainer {
    margin: auto;
  }
}
</style>
